export default __webpack_public_path__ + "static/media/business_background.546d6388.png";